<template>
    <auth-layout id="password-forget-page" class="h-100">
        <div class="col-12 col-md-6 col-lg-4">
            <div class="row py-4">
                <div class="col-12">
                    <h2>{{ $t('cdb.passwordReset.title') }}</h2>
                    <div class="alert alert-secondary mt-4">
                        {{ $t('cdb.passwordReset.info') }}
                    </div>
                </div>
            </div>

            <section id="login-form">
                <div class="row">
                    <div class="col-12">
                        <b-form-group
                            :label="$t('cdb.profile.form.email.label')"
                            label-for="email"
                        >
                            <input id="email" class="form-control" :placeholder="$t('cdb.profile.form.email.label')" type="text" v-model="email"/>
                        </b-form-group>

                        <b-form-group
                            :label="$t('cdb.profile.form.password.filler')"
                            label-for="password"
                        >
                            <input id="password" class="form-control" :placeholder="$t('cdb.profile.form.password.filler')" type="password" v-model="password"/>
                        </b-form-group>

                        <b-form-group
                            :label="$t('cdb.profile.form.password_repeat.label')"
                            label-for="password_confirmation"
                        >
                            <input id="password_confirmation" class="form-control" :placeholder="$t('cdb.profile.form.password_repeat.label')" type="password" v-model="password_confirmation"/>
                        </b-form-group>
                    </div>

                    <div class="col-12 d-flex justify-content-end p-0">
                        <div class="col-12 col-xl-6 d-flex justify-content-end">
                            <button class="btn btn-primary" @click="handleResetPassword" :disabled="btn_disabled" block>{{ $t('cdb.changePassword.submit') }}</button>
                        </div>
                    </div>
                </div>
                <div v-if="error" class="py-3 text-danger">
                    <span v-for="errorMessage in error" :key="errorMessage">{{ $t(errorMessage) }}<br /></span>
                </div>
            </section>
        </div>
    </auth-layout>
</template>

<script>
import AuthLayout from "../../layouts/AuthLayout.vue";
import { BFormGroup } from "bootstrap-vue";
export default {
    components: {
        AuthLayout,
        BFormGroup
    },
    data() {
        return {
            email: '',
            password: '',
            password_confirmation: '',
            error: [],
            btn_disabled: false,
            errorTimer: '',
        }
    },
    methods: {
        handleResetPassword() {
            this.error = [];

            this.$axios.post('api/reset-password', {
                email: this.email,
                token: this.$route.params.token,
                password: this.password,
                password_confirmation: this.password_confirmation
            })
                .then(response => {
                    if (response.data.success) {
                        this.btn_disabled = true;
                        this.$goTo('login')
                    } else {
                        this.error = [`${this.$t('cdb.passwordChange.errorMessage')}`];
                    }
                })
                .catch(error => {
                    if(error.response.data.errors.email){
                        error.response.data.errors.email.forEach(error => {
                            this.error.push(error)
                        })
                    }

                    if(error.response.data.errors.password){
                        error.response.data.errors.password.forEach(error => {
                            this.error.push(error)
                        })
                    }

                    clearTimeout(this.errorTimer);
                    this.errorTimer = setTimeout(() => {
                        this.error = '';
                    }, 10000);
                });
        }
    },
    head: {
        title: function () {
            return {
                inner: this.$root.whitelabel.state.settings.meta_title,
                complement: this.$t('meta.auth.passwordReset.title')
            }
        },
        meta: function () {
            return [
                { name: 'description', content: this.$t('meta.auth.passwordReset.description') }
            ]
        }
    }
}
</script>
